import React from "react";

// `outline` mapt op de bestaande .btn-outline-green uit base.css (wit vlak, groene rand en
// tekst) in plaats van op .btn: die klasse bestond al voor precies deze knopsoort, maar was
// alleen via een handmatige className bereikbaar. Zonder deze tak viel variant="outline"
// stil terug op de primaire (gevulde) knop — een variant die niets doet is erger dan een
// variant die niet bestaat. `secondary` is een alias van `outline` (secundaire actie naast
// een primaire knop).
const VARIANT_CLASS = {
  primary: "btn",
  secondary: "btn-outline-green",
  ghost: "btn ghost",
  outline: "btn-outline-green",
};

export default function Button({
  as: Tag = "button",
  variant = "primary",
  size,
  className = "",
  children,
  ...props
}) {
  const base = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  // .btn--sm hoort bij .btn; de outline-knop heeft zijn eigen maatvoering en krijgt hem niet.
  const sizeClass = size === "sm" && base !== VARIANT_CLASS.outline ? "btn--sm" : "";
  const classes = [base, sizeClass, className].filter(Boolean).join(" ");
  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
}
